<template>
  <div>
    <div class="tab-title">{{ selectNode.name }}</div>
    <el-tabs v-model="active" v-if="name && formConfig.length > 0" :class="[(selectNode.type === 'CC' && !isProcess)?'set-tabs set-tabs-3':'set-tabs']">
      <el-tab-pane :label="name" name="properties">
        <component :is="(selectNode.type||'').toLowerCase()" :config="selectNode.props"  :isProcess="isProcess" setType="base"/>
      </el-tab-pane>
      <el-tab-pane label="表单操作权限" name="permissions">
        <form-authority-config :isProcess="isProcess"/>
      </el-tab-pane>
      <!-- 抄送多了一个高级设置  审批流没有高级设计-->
      <el-tab-pane label="高级设置" name="advancedSetting" v-if="selectNode.type === 'CC' && !isProcess">
        <component :is="(selectNode.type||'').toLowerCase()" :config="selectNode.props" setType="pro"/>
      </el-tab-pane>
    </el-tabs>
    <component :is="(selectNode.type||'').toLowerCase()" v-else :config="selectNode.props"/>
  </div>
</template>

<script>
import Approval from './ApprovalNodeConfig.vue'
import Task from './TaskNodeConfig.vue'
import Condition from './ConditionNodeConfig.vue'
import Inclusive from './InclusiveNodeConfig.vue'
import Delay from './DelayNodeConfig.vue'
import Cc from './CcNodeConfig.vue'
import Trigger from './TriggerNodeConfig.vue'
import FormAuthorityConfig from './FormAuthorityConfig.vue'
import Root from './RootNodeConfig.vue'
import Subprocess from './SubprocessNodeConfig.vue'

export default {
  name: "NodeConfig",
  components: {
    Approval,
    Task,
    Condition,
    Inclusive,
    Trigger,
    Delay,
    Root,
    Cc,
    Subprocess,
    FormAuthorityConfig
  },
  props: {
    isProcess: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      active: 'properties',
    }
  },
  computed: {
    selectNode() {
      return this.$store.state.selectedNode
    },
    formConfig() {
      return this.$store.state.design.formItems
    },
    name() {
      switch (this.selectNode.type) {
        case 'ROOT':
          return '设置发起人';
        case 'APPROVAL':
          return '设置审批人';
        case 'TASK':
          return '设置办理人';
        case 'CC':
          return '设置抄送人';
        default:
          return null;
      }
    }
  },
  methods: {}
}
</script>

<style lang="scss" scoped>
.tab-title{
  line-height: 1;
  height: 32px;
  font-size: 16px;
  font-weight: 500;
  color: #2F3030;
  padding-left: 6px;
  position: relative;
  font-family: PingFang SC, PingFang SC;
  &::before{
    content: '';
    position: absolute;
    left: 0;
    top: 1px;
    width: 2px;
    height: 15px;
    background: #00B498;
  }
}
.set-tabs{
  width: 460px;
  /deep/{
    .el-tabs__header{
      border-bottom: none;
    }
    .el-tabs__nav{
      border: none;
    }
    .el-tabs__active-bar,
    .el-tabs__nav-wrap::after{
      display: none;
    }
    .el-tabs__item{
      height: 32px;
      line-height: 32px;
      width: 228px;
      // width: 200px;
      padding: 0;
      text-align: center;
      box-sizing: border-box;
      color: #2F3030 ;
      border:1px solid #E3E6E5;
      
     
    }
     #tab-properties{
      border-radius: 4px 0 0 4px;
    }
    #tab-permissions{
      border-radius: 0 4px 4px 0;
    }
    .el-tabs__item.is-active{
      color: #00B498 ;
      border:1px solid #00B498;
    }
  }
}
.set-tabs-3{
  /deep/{
    .el-tabs__item{
      width: 153px;
    }
    #tab-permissions{
        border-radius: 0;
    }
    #tab-advancedSetting{
      border-radius: 0 4px 4px 0;
    }
  }

}
</style>
